import { render, staticRenderFns } from "./ZaitonTransferContractDesignV2Kurdish.vue?vue&type=template&id=5d03f2da&scoped=true&"
import script from "./ZaitonTransferContractDesignV2Kurdish.vue?vue&type=script&lang=js&"
export * from "./ZaitonTransferContractDesignV2Kurdish.vue?vue&type=script&lang=js&"
import style0 from "./ZaitonTransferContractDesignV2Kurdish.vue?vue&type=style&index=0&id=5d03f2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d03f2da",
  null
  
)

export default component.exports